// Scroll entrance animations. Elements with [data-reveal] start hidden (only while <html>
// has .has-reveal, set in <head>) and get .is-revealed the first time they enter the viewport.
if (document.documentElement.classList.contains("has-reveal")) {
  const revealItems = document.querySelectorAll("[data-reveal]");
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-revealed");
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: "0px 0px -8% 0px",
    threshold: 0.12
  });
  revealItems.forEach(item => observer.observe(item));

  // Turning on reduced motion mid-visit shows everything at once
  window.matchMedia("(prefers-reduced-motion: reduce)").addEventListener("change", event => {
    if (!event.matches) return;
    revealItems.forEach(item => item.classList.add("is-revealed"));
  });
}